module.exports = __webpack_public_path__ + "img/IC.8508d042.svg";